import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

export const RestartOptionsSubForm = () => {
  const { register, formState: { errors }, control } = useFormContext();
  const { t } = useTranslation();

  const isAutorestart = useWatch({ name: 'autorestart.restart' });

  const commonStylesProps = {
    className: st.SettingItem,
    titleClassName: st.SettingItem__Title,
    contentClassName: st.SettingItem__Content,
  };

  return (
    <>
      <Control.Switch
        className={st.Switch}
        control={control}
        id="autorestart.restart"
        label={t('videoAnalytics:editAndCreateStreamsPageTitles.automatically_restart')}
        name="autorestart.restart"
      />

      <SettingsItemWrapper
        title={t('videoAnalytics:editAndCreateStreamsPageTitles.attempts_count')}
        {...commonStylesProps}
        disabled={!isAutorestart}
      >
        <Control.Input
          disabled={!isAutorestart}
          {...register('autorestart.attempt_count', {
            min: validate.gte(1),
            max: validate.lte(32767),
            validate: validate.integer(),
          })}
          errors={errors}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        title={t('videoAnalytics:editAndCreateStreamsPageTitles.restart_delay_in_seconds')}
        {...commonStylesProps}
        disabled={!isAutorestart}
      >
        <Control.Input
          disabled={!isAutorestart}
          {...register('autorestart.delay', {
            min: validate.gte(1),
            max: validate.lte(2147483647),
            validate: validate.integer(),
          })}
          errors={errors}
        />
      </SettingsItemWrapper>
    </>
  );
};
